import { validateWindowSize, isLocalUrl } from '../utils.js';
export default function cardWidget7() {
  const widgetName = 'cardWidget7';
  const widgetOpts = cardWidget7Opts;

  // you can remove this and import the validateWindowSize auxiliary function under Helpers/helpers.js
  const breakpoint = 800;
  const isDesktopScreen = validateWindowSize(breakpoint);
  const wrapContainerClass = 'cardWidget7-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    showDescription: false,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      let urlAttribute = isLocalUrl(URL) ? '' : 'target="_blank"';

      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
              ${URL ? `<a href="${URL}" class="button" ${urlAttribute}>More</a>` : ''}
            </div>
          </div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }
      URL ? $cardItem.addClass('only-url') : $cardItem.addClass('empty-card').removeAttr('href');
    });
  }
}
